import { cloneDeep, concat, get, isEmpty } from 'lodash';
import type from './DamFile.type';
import { Page_Size } from '../../../../../Components/helper';

const initialState = {
  damFileList: [],
  totalCount: 0,
  filterValues: {
    colorTheme: [],
    primaryColour: [],
    secondaryColour: [],
    folder: [],
    fileType: [],
    assetType: [],
    productType: [],
    brand: [],
    gradingGroups: [],
    category1: [],
    category2: [],
    category3: [],
    category4: [],
    dynamicDropdown: [],
    pageIndex: 1,
    pageSize: Page_Size,
    tags: [],
  },
  folderOptions: [],
};

const DamProductFileReducer = (state = initialState, action) => {
  switch (action.type) {
    case type.FETCH_PRODUCT_DAM_FILE_LIST:
      const updatedDamArry = cloneDeep(setArrayByCase(state.damFileList, action.payload));
      return {
        ...state,
        damFileList: updatedDamArry,
        totalCount: action?.payload?.totalCount,
      };
    case type.DAM_PRODUCT_FILE_SET_FILTER_SORT_DATA:
      return {
        ...state,
        filterValues: { ...state.filterValues, ...action.payload },
      };
    case type.SET_PRODUCT_FOLDERS_OPTION:
      return {
        ...state,
        folderOptions: action.payload.data,
      };
    default:
      return state;
  }
};

const setArrayByCase = (array, payload) => {
  let newArray;
  if (!isEmpty(get(payload, 'searchText')) && get(payload, 'isScrolled')) {
    newArray = [...array, ...payload.data];
  } else if (!isEmpty(get(payload, 'searchText'))) {
    newArray = payload.data;
  } else if (get(payload, 'isScrolled')) {
    newArray = concat(array, payload.data);
  } else {
    newArray = payload.data;
  }
  return newArray;
};

export default DamProductFileReducer;
